// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2qi2Y","image":"Header_image__2pzdK","name":"Header_name__OZIo9","info":"Header_info__2zyQm","infoRow":"Header_infoRow__rKeUC"};